import React, { Component } from "react";
import { Typography } from "@material-ui/core";

const style = {
    image: {
        width: 32,
        height: 32,
        cursor: 'pointer'
    }
};

export default (props) => {
    return (
      <div>
        <img onClick={() => props.onClick && props.onClick(props.country)} style={style.image} src={`https://www.countryflags.io/${props.country}/flat/64.png`}/>
      </div>
    )
}



// WEBPACK FOOTER //
// ./src/components/LanguageMenu/Language/Language.jsx